import styled from 'styled-components';

const StyledLogo = styled.div`
  display: flex;
  position: relative;
  background-color: ${({ theme }) => theme.COLORS.BRAND};
  color: ${({ theme }) => theme.COLORS.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  min-width: ${({ theme }) => theme.DIMENSIONS.LOGO_WIDTH};
  height: 45px;
  justify-content: center;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    border-right: 25px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-left: 25px solid ${({ theme }) => theme.COLORS.BRAND};
    border-top: 0;
    border-bottom: 45px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
    height: 0;
    width: 0;
  }
`;

export default StyledLogo;
